module.exports = __webpack_public_path__ + "img/change.ca4da304.png";